module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-resource"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.resourceList
    }
  }, [_vm._l((_vm.columnList), function(column, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "label": column.label,
        "prop": column.prop,
        "width": column.width
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [_vm._v("\n                " + _vm._s(column.prop ? (row[column.prop] || '--') : '') + "\n            ")]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": 250,
      "prop": "operat"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return _c('div', {
          staticClass: "operat-wrap"
        }, [_c('el-button', {
          staticClass: "operat-item",
          attrs: {
            "type": "text",
            "disabled": !['png', 'video', 'pdf'].includes(row.file_type)
          },
          on: {
            "click": function($event) {
              return _vm.handlePreivew(row)
            }
          }
        }, [_c('i', {
          staticClass: "icon-smart-view"
        }), _vm._v("预览\n                ")]), _vm._v(" "), _c('el-button', {
          staticClass: "operat-item",
          attrs: {
            "type": "text",
            "disabled": row.file_type === 'png'
          },
          on: {
            "click": function($event) {
              return _vm.handleDownload(row)
            }
          }
        }, [_c('i', {
          staticClass: "icon-xiazai"
        }), _vm._v("下载\n                ")])], 1)
      }
    }])
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isShow,
      "center": "",
      "close-on-click-modal": false,
      "destroy-on-close": true,
      "custom-class": "pro-video-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShow = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "src": _vm.videoUrl,
      "autoplay": "",
      "controls": ""
    }
  }, [_vm._v("\n            抱歉，您的浏览器不支持内嵌视频，不过不用担心，你可以 "), _c('a', {
    attrs: {
      "href": _vm.videoUrl
    }
  }, [_vm._v("下载")]), _vm._v("\n            并用你喜欢的播放器观看!\n        ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5b455421!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application/information.vue
// module id = Gue4
// module chunks = 15